import palette from 'Theme/palette'

const shadows = {
  block: `0 4px 12px 0 ${palette.black}14`,
  header: `0px 12px 20px 0px ${palette.black}12`,
}

export default shadows
